import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = { class: "mb-8 flex items-center justify-between" }
const _hoisted_3 = { class: "bg-white rounded-lg shadow-sm border border-gray-200" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_5 = {
  key: 1,
  class: "p-12 text-center text-gray-400"
}
const _hoisted_6 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_7 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_8 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_9 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_10 = { class: "flex items-center space-x-3" }
const _hoisted_11 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_17 = { class: "space-y-1" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "space-y-1" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "space-y-1" }

import { onMounted, ref } from 'vue';
import { useServicesStore } from '@/store/services';
import { useOrganizationStore } from '@/store/organizations';
import { useNotificationStore } from '@/store/notifications';
import type { Service } from '@/config/types/responses';
import Header from '@/components/header.vue';
import SideBar from '@/components/sidebar.vue';
import Modal from '@/components/modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'services',
  setup(__props) {

const servicesStore = useServicesStore();
const organizationStore = useOrganizationStore();
const notificationStore = useNotificationStore();

const showSubscribeModal = ref(false);
const submitLoading = ref(false);

const subscribeForm = ref({
  organizationId: '',
  serviceId: '',
  rate: '',
});

onMounted(async () => {
  await servicesStore.fetchServices();
  await organizationStore.fetchOrganizations(1);
});

function formatDate(input: string) {
  if (!input) return '—';
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(d);
}

function openSubscribeForService(service: Service) {
  subscribeForm.value.serviceId = service.id;
  showSubscribeModal.value = true;
}

function closeSubscribeModal() {
  showSubscribeModal.value = false;
  subscribeForm.value = { organizationId: '', serviceId: '', rate: '' };
  servicesStore.error = null;
}

async function handleSubscribe() {
  if (!subscribeForm.value.organizationId || !subscribeForm.value.serviceId) {
    notificationStore.showError('Validation Error', 'Please select both an organization and a service.');
    return;
  }
  submitLoading.value = true;
  const ok = await servicesStore.createSubscription(
    subscribeForm.value.organizationId,
    subscribeForm.value.serviceId,
    subscribeForm.value.rate || undefined,
  );
  submitLoading.value = false;
  if (ok) {
    notificationStore.showSuccess('Subscribed', servicesStore.success ?? 'Subscription created.');
    closeSubscribeModal();
  } else {
    notificationStore.showError('Subscription Failed', servicesStore.error ?? 'An error occurred.');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", null, [
          _createElementVNode("h2", { class: "text-2xl font-bold text-green-800" }, "Services"),
          _createElementVNode("p", { class: "text-gray-600 text-sm mt-1" }, "Manage available services and subscribe organizations")
        ], -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showSubscribeModal.value = true)),
          class: "bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 text-white px-5 py-2.5 rounded-lg flex items-center font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 transform hover:scale-[1.02]"
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fa-solid fa-plus mr-2" }, null, -1),
          _createTextVNode(" Subscribe Organization ", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(servicesStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
            ])))
          : (!_unref(servicesStore).services?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fa-solid fa-cubes text-4xl mb-3" }, null, -1),
                _createElementVNode("p", { class: "text-sm" }, "No services found", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Service"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesStore).services, (service) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: service.id,
                        class: "hover:bg-gray-50 transition-colors"
                      }, [
                        _createElementVNode("td", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "h-8 w-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" }, [
                              _createElementVNode("i", { class: "fa-solid fa-cube text-green-700 text-xs" })
                            ], -1)),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(service.name), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_12, [
                          _createElementVNode("span", {
                            class: _normalizeClass(service.status === 'Active' || service.status === 'ACTIVE'
                  ? 'px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full'
                  : 'px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full')
                          }, _toDisplayString(service.status), 3)
                        ]),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(formatDate(service.createdAt)), 1),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (openSubscribeForService(service)),
                            title: "Subscribe organization",
                            class: "text-green-700 hover:text-green-900"
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fa-solid fa-link" }, null, -1)
                          ]), 8, _hoisted_15)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
      ]),
      _createVNode(Modal, {
        show: showSubscribeModal.value,
        title: "Subscribe Organization to Service",
        size: "max-w-lg",
        onClose: closeSubscribeModal
      }, {
        default: _withCtx(() => [
          (submitLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[11] || (_cache[11] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "space-y-5",
                onSubmit: _withModifiers(handleSubscribe, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Organization", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subscribeForm.value.organizationId) = $event)),
                    required: "",
                    class: "block w-full pl-4 pr-3 py-3 border border-gray-300 rounded-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white"
                  }, [
                    _cache[12] || (_cache[12] = _createElementVNode("option", {
                      value: "",
                      disabled: ""
                    }, "Select an organization", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizationStore).organizationResults, (org) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: org.id,
                        value: org.id
                      }, _toDisplayString(org.name), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, subscribeForm.value.organizationId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Service", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subscribeForm.value.serviceId) = $event)),
                    required: "",
                    class: "block w-full pl-4 pr-3 py-3 border border-gray-300 rounded-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white"
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("option", {
                      value: "",
                      disabled: ""
                    }, "Select a service", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesStore).services, (svc) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: svc.id,
                        value: svc.id
                      }, _toDisplayString(svc.name), 9, _hoisted_20))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, subscribeForm.value.serviceId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, [
                    _createTextVNode("Custom Rate "),
                    _createElementVNode("span", { class: "text-gray-400 font-normal" }, "(optional)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subscribeForm.value.rate) = $event)),
                    type: "number",
                    step: "any",
                    min: "0",
                    class: "block w-full pl-4 pr-3 py-3 border border-gray-300 rounded-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                    placeholder: "Leave blank to use default rate"
                  }, null, 512), [
                    [_vModelText, subscribeForm.value.rate]
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-gray-400 text-xs" }, "If left blank, the service's default rate will apply", -1))
                ]),
                _createElementVNode("div", { class: "flex justify-end space-x-2 pt-2" }, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeSubscribeModal,
                    class: "px-4 py-2 bg-gray-200 text-gray-700 rounded-sm hover:bg-gray-300 text-sm"
                  }, " Cancel "),
                  _cache[18] || (_cache[18] = _createElementVNode("button", {
                    type: "submit",
                    class: "bg-gradient-to-r from-green-700 to-green-800 text-white px-6 py-2 rounded-md flex items-center font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 disabled:opacity-50 text-sm"
                  }, [
                    _createElementVNode("i", { class: "fa-solid fa-link mr-2" }),
                    _createTextVNode(" Subscribe ")
                  ], -1))
                ])
              ], 32))
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})